module.exports = "<app-calendar-style [agenda]=\"agenda\"></app-calendar-style>\n<div #calendar id=\"calendar\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/full-calendar/fullcalendar.html
// module id = ./src/app/calendar/full-calendar/fullcalendar.html
// module chunks = main